var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectFunnel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_494_51965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9131 1.00848C21.7973 0.809617 21.5852 0.6875 21.3555 0.6875H0.644534C0.41478 0.6875 0.202686 0.809617 0.0868424 1.00852C-0.0283139 1.20742 -0.0289584 1.45226 0.0849947 1.65176L2.15501 5.19922H19.845L21.915 1.65176C22.0289 1.45221 22.0283 1.20738 21.9131 1.00848Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46973 11L7.3112 14.2227H14.6888L16.5303 11H5.46973Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8916 6.48828L4.73316 9.71094H17.2669L19.1084 6.48828H2.8916Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77734 15.5117V20.668C7.77734 21.0242 8.06562 21.3125 8.42188 21.3125H13.5781C13.9344 21.3125 14.2227 21.0242 14.2227 20.668V15.5117H7.77734Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_494_51965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectFunnel);
export default __webpack_public_path__ + "static/media/projectFunnel.0cbe9dfbd97ca7f4bfba8709cdd414f0.svg";
export { ForwardRef as ReactComponent };